import classNames from "classnames";

/** Renders the Carousel Items */
const CarouselItem = ({ count = "0", title = "", className = "" }) => {
  return (
    <li>
      <i className={classNames("carousel-list-icon", className)}></i>
      <div className="carousel-list-content">
        <b> {count}</b>
        <span>{title}</span>
      </div>
    </li>
  );
};

export default CarouselItem;
